!(function (e, t) {
  'object' == typeof exports && 'object' == typeof module
    ? (module.exports = t())
    : 'function' == typeof define && define.amd
      ? define('SecureBAAS', [], t)
      : 'object' == typeof exports
        ? (exports.SecureBAAS = t())
        : (e.SecureBAAS = t())
})(this, function () {
  return (() => {
    'use strict'
    var e = {
      d: (ta, sa) => {
        for (let rName in sa){
          if (sa.hasOwnProperty(rName)) {
            e.o(sa, rName) &&
              !e.o(ta, rName) &&
              Object.defineProperty(ta, rName, { enumerable: !0, get: sa[rName] })
          }
        }
      },
      o: (ea, tb) => Object.prototype.hasOwnProperty.call(ea, tb),
      r: eb => {
        'undefined' != typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(eb, Symbol.toStringTag, { value: 'Module' }),
          Object.defineProperty(eb, '__esModule', { value: !0 })
      }
    },
      t = {}
    e.r(t), e.d(t, { SecurityHelper: () => B })
    class s {
      static create(...ec) {
        return new this(...ec)
      }
      mixIn(ed) {
        return Object.assign(this, ed)
      }
      clone() {
        const ed = new this.constructor()
        return Object.assign(ed, this), ed
      }
    }
    class r extends s {
      constructor(ef = [], ta = 4 * ef.length) {
        super()
        let sab = ef
        if (
          (sab instanceof ArrayBuffer && (sab = new Uint8Array(sab)),
            (sab instanceof Int8Array ||
              sab instanceof Uint8ClampedArray ||
              sab instanceof Int16Array ||
              sab instanceof Uint16Array ||
              sab instanceof Int32Array ||
              sab instanceof Uint32Array ||
              sab instanceof Float32Array ||
              sab instanceof Float64Array) &&
            (sab = new Uint8Array(sab.buffer, sab.byteOffset, sab.byteLength)),
            sab instanceof Uint8Array)
        ) {
          const eab = sab.byteLength,
            tac = []
          for (let rbc = 0; rbc < eab; rbc += 1)
            tac[rbc >>> 2] |= sab[rbc] << (24 - (rbc % 4) * 8)
              ; (this.words = tac), (this.sigBytes = eab)
        } else (this.words = ef), (this.sigBytes = ta)
      }
      static random(ecb) {
        const tbc = [],
          saf = eab => {
            let tac = eab,
              scon = 987654321
            const rConst = 4294967295
            return () => {
              ; (scon = (36969 * (65535 & scon) + (scon >> 16)) & rConst),
                (tac = (18e3 * (65535 & tac) + (tac >> 16)) & rConst)
              let eConst = ((scon << 16) + tac) & rConst
              return (
                (eConst /= 4294967296),
                (eConst += 0.5),
                eConst * (secureRandom() > 0.5 ? 1 : -1)
              )
            }
          }
        for (let rLoop, nLoop = 0; nLoop < ecb; nLoop += 4) {
          const eLoop = saf(4294967296 * (rLoop || secureRandom()))
            ; (rLoop = 987654071 * eLoop()), tbc.push((4294967296 * eLoop()) | 0)
        }
        return new r(tbc, ecb)
      }
      toString(eToString = n) {
        return eToString.stringify(this)
      }
      concat(eConcat) {
        const tConcat = this.words,
          saConcat = eConcat.words,
          rsaConcat = this.sigBytes,
          nsaConcat = eConcat.sigBytes
        if ((this.clamp(), rsaConcat % 4))
          for (let esaConcat = 0; esaConcat < nsaConcat; esaConcat += 1) {
            const nsbConcat = (saConcat[esaConcat >>> 2] >>> (24 - (esaConcat % 4) * 8)) & 255
            tConcat[(rsaConcat + esaConcat) >>> 2] |= nsbConcat << (24 - ((rsaConcat + esaConcat) % 4) * 8)
          }
        else for (let esbConcat = 0; esbConcat < nsaConcat; esbConcat += 4) tConcat[(rsaConcat + esbConcat) >>> 2] = saConcat[esbConcat >>> 2]
        return (this.sigBytes += nsaConcat), this
      }
      clamp() {
        const { words: eClamp, sigBytes: tClamp } = this
          ; (eClamp[tClamp >>> 2] &= 4294967295 << (32 - (tClamp % 4) * 8)),
            (eClamp.length = Math.ceil(tClamp / 4))
      }
      clone() {
        const eClone = super.clone.call(this)
        return (eClone.words = this.words.slice(0)), eClone
      }
    }
    const n = {
      stringify(eConstStr) {
        const { words: tConstStr, sigBytes: sConstStr } = eConstStr,
          rConstStr = []
        for (let eConstStrFor = 0; eConstStrFor < sConstStr; eConstStrFor += 1) {
          const sConstStrFor = (tConstStr[eConstStrFor >>> 2] >>> (24 - (eConstStrFor % 4) * 8)) & 255
          rConstStr.push((sConstStrFor >>> 4).toString(16)), rConstStr.push((15 & sConstStrFor).toString(16))
        }
        return rConstStr.join('')
      },
      parse(eParse) {
        const tParse = eParse.length,
          sParse = []
        for (let rParse = 0; rParse < tParse; rParse += 2)
          sParse[rParse >>> 3] |= parseInt(eParse.substr(rParse, 2), 16) << (24 - (rParse % 8) * 4)
        return new r(sParse, tParse / 2)
      }
    },
      o = {
        stringify(eOStr) {
          const { words: tOStr, sigBytes: sOStr } = eOStr,
            rOStr = []
          for (let eOStrF = 0; eOStrF < sOStr; eOStrF += 1) {
            const sOStrF = (tOStr[eOStrF >>> 2] >>> (24 - (eOStrF % 4) * 8)) & 255
            rOStr.push(String.fromCharCode(sOStrF))
          }
          return rOStr.join('')
        },
        parse(eParseCon) {
          const tParseCon = eParseCon.length,
            sParseCon = []
          for (let rParseCon = 0; rParseCon < tParseCon; rParseCon += 1)
            sParseCon[rParseCon >>> 2] |= (255 & eParseCon.charCodeAt(rParseCon)) << (24 - (rParseCon % 4) * 8)
          return new r(sParseCon, tParseCon)
        }
      },
      i = {
        stringify(eIStr) {
          try {
            return decodeURIComponent(escape(o.stringify(eIStr)))
          } catch (eIStrErr) {
            throw new Error('Malformed UTF-8 data')
          }
        },
        parse: eIParse => o.parse(unescape(encodeURIComponent(eIParse)))
      }
    class c extends s {
      constructor() {
        super(), (this._minBufferSize = 0)
      }
      reset() {
        ; (this._data = new r()), (this._nDataBytes = 0)
      }
      _append(eAppe) {
        let tAppend = eAppe
        'string' == typeof tAppend && (tAppend = i.parse(tAppend)),
          this._data.concat(tAppend),
          (this._nDataBytes += tAppend.sigBytes)
      }
      _process(eProcess) {
        let tProcess
        const { _data: sProcessConst, blockSize: nProcessConst } = this,
          oProcessConst = sProcessConst.words,
          iProcessConst = sProcessConst.sigBytes
        let cProcessConst = iProcessConst / (4 * nProcessConst)
        cProcessConst = eProcess ? Math.ceil(cProcessConst) : Math.max((0 | cProcessConst) - this._minBufferSize, 0)
        const aProcessConst = cProcessConst * nProcessConst,
          hProcessConst = Math.min(4 * aProcessConst, iProcessConst)
        if (aProcessConst) {
          for (let eProcessFor = 0; eProcessFor < aProcessConst; eProcessFor += nProcessConst) this._doProcessBlock(oProcessConst, eProcessFor)
            ; (tProcess = oProcessConst.splice(0, aProcessConst)), (sProcessConst.sigBytes -= hProcessConst)
        }
        return new r(tProcess, hProcessConst)
      }
      clone() {
        const eCloned = super.clone.call(this)
        return (eCloned._data = this._data.clone()), eCloned
      }
    }
    class a extends c {
      constructor(eSuperConstruct) {
        super(),
          (this.blockSize = 16),
          (this.cfg = Object.assign(new s(), eSuperConstruct)),
          this.reset()
      }
      static _createHelper(eCreateHelper) {
        return (tCreateHelper, sCreateHelper) => new eCreateHelper(sCreateHelper).finalize(tCreateHelper)
      }
      static _createHmacHelper(ecreateHmacHelper) {
        return (tcreateHmacHelper, screateHmacHelper) => new h(ecreateHmacHelper, screateHmacHelper).finalize(tcreateHmacHelper)
      }
      reset() {
        super.reset.call(this), this._doReset()
      }
      update(eUpdateD) {
        return this._append(eUpdateD), this._process(), this
      }
      finalize(eFinalize) {
        return eFinalize && this._append(eFinalize), this._doFinalize()
      }
    }
    class h extends s {
      constructor(eHClasss, tHClasss) {
        super()
        const sHClasss = new eHClasss()
        this._hasher = sHClasss
        let rHClasss = tHClasss
        'string' == typeof rHClasss && (rHClasss = i.parse(rHClasss))
        const nHClasss = sHClasss.blockSize,
          oHClasss = 4 * nHClasss
        rHClasss.sigBytes > oHClasss && (rHClasss = sHClasss.finalize(tHClasss)), rHClasss.clamp()
        const cHClasss = rHClasss.clone()
        this._oKey = cHClasss
        const aHClasss = rHClasss.clone()
        this._iKey = aHClasss
        const hHClasss = cHClasss.words,
          lHClasss = aHClasss.words
        for (let eHClassFor = 0; eHClassFor < nHClasss; eHClassFor += 1) (hHClasss[eHClassFor] ^= 1549556828), (lHClasss[eHClassFor] ^= 909522486)
          ; (cHClasss.sigBytes = oHClasss), (aHClasss.sigBytes = oHClasss), this.reset()
      }
      reset() {
        const eResetFunc = this._hasher
        eResetFunc.reset(), eResetFunc.update(this._iKey)
      }
      update(eUpdateFunc) {
        return this._hasher.update(eUpdateFunc), this
      }
      finalize(eFinalizeFunc) {
        const tFinalizeFunc = this._hasher,
          sFinalizeFunc = tFinalizeFunc.finalize(eFinalizeFunc)
        return tFinalizeFunc.reset(), tFinalizeFunc.finalize(this._oKey.clone().concat(sFinalizeFunc))
      }
    }
    const l = {
      stringify(eLStr) {
        const { words: tLStr, sigBytes: sLStr } = eLStr,
          rLStr = this._map
        eLStr.clamp()
        const nLStr = []
        for (let eLStrfor = 0; eLStrfor < sLStr; eLStrfor += 3) {
          const oLStrfor =
            (((tLStr[eLStrfor >>> 2] >>> (24 - (eLStrfor % 4) * 8)) & 255) << 16) |
            (((tLStr[(eLStrfor + 1) >>> 2] >>> (24 - ((eLStrfor + 1) % 4) * 8)) & 255) << 8) |
            ((tLStr[(eLStrfor + 2) >>> 2] >>> (24 - ((eLStrfor + 2) % 4) * 8)) & 255)
          for (let tLStrfor = 0; tLStrfor < 4 && eLStrfor + 0.75 * tLStrfor < sLStr; tLStrfor += 1)
            nLStr.push(rLStr.charAt((oLStrfor >>> (6 * (3 - tLStrfor))) & 63))
        }
        const oLConst = rLStr.charAt(64)
        if (oLConst) for (; nLStr.length % 4;) nLStr.push(oLConst)
        return nLStr.join('')
      },
      parse(eLParse) {
        let tLParse = eLParse.length
        const sLParse = this._map
        let nLParse = this._reverseMap
        if (!nLParse) {
          ; (this._reverseMap = []), (nLParse = this._reverseMap)
          for (let eLParseFor = 0; eLParseFor < sLParse.length; eLParseFor += 1) nLParse[sLParse.charCodeAt(eLParseFor)] = eLParseFor
        }
        const oLParseFor = sLParse.charAt(64)
        if (oLParseFor) {
          const sLParseFor = eLParse.indexOf(oLParseFor)
            ; -1 !== sLParseFor && (tLParse = sLParseFor)
        }
        return ((eLParseReturn, tLParseReturn, sLParseReturn) => {
          const nLParseReturn = []
          let oLParseReturn = 0
          for (let rLParseReturn = 0; rLParseReturn < tLParseReturn; rLParseReturn += 1)
            if (rLParseReturn % 4) {
              const tLParseReturnFor =
                (sLParseReturn[eLParseReturn.charCodeAt(rLParseReturn - 1)] << ((rLParseReturn % 4) * 2)) |
                (sLParseReturn[eLParseReturn.charCodeAt(rLParseReturn)] >>> (6 - (rLParseReturn % 4) * 2))
                ; (nLParseReturn[oLParseReturn >>> 2] |= tLParseReturnFor << (24 - (oLParseReturn % 4) * 8)), (oLParseReturn += 1)
            }
          return r.create(nLParseReturn, oLParseReturn)
        })(eLParse, tLParse, nLParse)
      },
      _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
    },
      f = [],
      d = [],
      u = eUMap => {
        const tUMap = Math.sqrt(eUMap)
        for (let sUMap = 2; sUMap <= tUMap; sUMap += 1) if (!(eUMap % sUMap)) return !1
        return !0
      },
      p = ePUMap => (4294967296 * (ePUMap - (0 | ePUMap))) | 0
    let y = 2,
      g = 0
    for (; g < 64;)
      u(y) &&
        (g < 8 && (f[g] = p(y ** 0.5)), (d[g] = p(y ** (1 / 3))), (g += 1)),
        (y += 1)
    const _ = []
    class w extends a {
      _doReset() {
        this._hash = new r(f.slice(0))
      }
      _doProcessBlock(eDoProcessBlock, tDoProcessBlock) {
        const sDoProcessBlock = this._hash.words
        let rDoProcessBlock = sDoProcessBlock[0],
          nDoProcessBlock = sDoProcessBlock[1],
          oDoProcessBlock = sDoProcessBlock[2],
          iDoProcessBlock = sDoProcessBlock[3],
          cDoProcessBlock = sDoProcessBlock[4],
          aDoProcessBlock = sDoProcessBlock[5],
          hDoProcessBlock = sDoProcessBlock[6],
          lDoProcessBlock = sDoProcessBlock[7]
        for (let sDoProcessBlockFor = 0; sDoProcessBlockFor < 64; sDoProcessBlockFor += 1) {
          if (sDoProcessBlockFor < 16) _[sDoProcessBlockFor] = 0 | eDoProcessBlock[tDoProcessBlock + sDoProcessBlockFor]
          else {
            const eDoProcessBlockFor = _[sDoProcessBlockFor - 15],
              tDoProcessBlockFor =
                ((eDoProcessBlockFor << 25) | (eDoProcessBlockFor >>> 7)) ^ ((eDoProcessBlockFor << 14) | (eDoProcessBlockFor >>> 18)) ^ (eDoProcessBlockFor >>> 3),
              rDoProcessBlockFor = _[sDoProcessBlockFor - 2],
              nDoProcessBlockFor =
                ((rDoProcessBlockFor << 15) | (rDoProcessBlockFor >>> 17)) ^ ((rDoProcessBlockFor << 13) | (rDoProcessBlockFor >>> 19)) ^ (rDoProcessBlockFor >>> 10)
            _[sDoProcessBlockFor] = tDoProcessBlockFor + _[sDoProcessBlockFor - 7] + nDoProcessBlockFor + _[sDoProcessBlockFor - 16]
          }
          const fDoProcessBlockFor = (rDoProcessBlock & nDoProcessBlock) ^ (rDoProcessBlock & oDoProcessBlock) ^ (nDoProcessBlock & oDoProcessBlock),
            uDoProcessBlockFor =
              ((rDoProcessBlock << 30) | (rDoProcessBlock >>> 2)) ^
              ((rDoProcessBlock << 19) | (rDoProcessBlock >>> 13)) ^
              ((rDoProcessBlock << 10) | (rDoProcessBlock >>> 22)),
            pDoProcessBlockFor =
              lDoProcessBlock +
              (((cDoProcessBlock << 26) | (cDoProcessBlock >>> 6)) ^
                ((cDoProcessBlock << 21) | (cDoProcessBlock >>> 11)) ^
                ((cDoProcessBlock << 7) | (cDoProcessBlock >>> 25))) +
              ((cDoProcessBlock & aDoProcessBlock) ^ (~cDoProcessBlock & hDoProcessBlock)) +
              d[sDoProcessBlockFor] +
              _[sDoProcessBlockFor]
            ; (lDoProcessBlock = hDoProcessBlock),
              (hDoProcessBlock = aDoProcessBlock),
              (aDoProcessBlock = cDoProcessBlock),
              (cDoProcessBlock = (iDoProcessBlock + pDoProcessBlockFor) | 0),
              (iDoProcessBlock = oDoProcessBlock),
              (oDoProcessBlock = nDoProcessBlock),
              (nDoProcessBlock = rDoProcessBlock),
              (rDoProcessBlock = (pDoProcessBlockFor + (uDoProcessBlockFor + fDoProcessBlockFor)) | 0)
        }
        ; (sDoProcessBlock[0] = (sDoProcessBlock[0] + rDoProcessBlock) | 0),
          (sDoProcessBlock[1] = (sDoProcessBlock[1] + nDoProcessBlock) | 0),
          (sDoProcessBlock[2] = (sDoProcessBlock[2] + oDoProcessBlock) | 0),
          (sDoProcessBlock[3] = (sDoProcessBlock[3] + iDoProcessBlock) | 0),
          (sDoProcessBlock[4] = (sDoProcessBlock[4] + cDoProcessBlock) | 0),
          (sDoProcessBlock[5] = (sDoProcessBlock[5] + aDoProcessBlock) | 0),
          (sDoProcessBlock[6] = (sDoProcessBlock[6] + hDoProcessBlock) | 0),
          (sDoProcessBlock[7] = (sDoProcessBlock[7] + lDoProcessBlock) | 0)
      }
      _doFinalize() {
        const eDoFinalize = this._data,
          tDoFinalize = eDoFinalize.words,
          sDoFinalize = 8 * this._nDataBytes,
          rDoFinalize = 8 * eDoFinalize.sigBytes
        return (
          (tDoFinalize[rDoFinalize >>> 5] |= 128 << (24 - (rDoFinalize % 32))),
          (tDoFinalize[14 + (((rDoFinalize + 64) >>> 9) << 4)] = Math.floor(sDoFinalize / 4294967296)),
          (tDoFinalize[15 + (((rDoFinalize + 64) >>> 9) << 4)] = sDoFinalize),
          (eDoFinalize.sigBytes = 4 * tDoFinalize.length),
          this._process(),
          this._hash
        )
      }
      clone() {
        const eSClone = super.clone.call(this)
        return (eSClone._hash = this._hash.clone()), eSClone
      }
    }
    const m = a._createHelper(w)
    a._createHmacHelper(w)
    var B = (function () {
      function eFuncB() {
        // This is intentional
      }
      return (
        (eFuncB.prototype.base64URLEncode = function (eBase64URLEncode) {
          return l.stringify(eBase64URLEncode).replace(/\+/g, '-').replace(/\//g, '_')
        }),
        (eFuncB.prototype.generateCodeVerifier = function () {
          return this.base64URLEncode(r.random(50)).replace(/\=/g, '')
        }),
        (eFuncB.prototype.generateCodeChallenge = function (eGenerateCodeChallenge) {
          return this.base64URLEncode(m(eGenerateCodeChallenge))
        }),
        (eFuncB.prototype.getCodeData = function () {
          return void 0 === this.code_challenge
            ? ((this.code_verifier = this.generateCodeVerifier()),
              (this.code_challenge = this.generateCodeChallenge(
                this.code_verifier
              )),
            {
              code_challenge: this.code_verifier,
              code_verifier: this.code_challenge
            })
            : {
              code_challenge: this.code_verifier,
              code_verifier: this.code_challenge
            }
        }),
        eFuncB
      )
    })()
    return t
  })()
})

const secureRandom = () => {
  const array = new Uint32Array(1);
  window.crypto.getRandomValues(array);
  return array[0] / (0xFFFFFFFF + 1);
};
